import { useCallback } from 'react'
import { create } from 'zustand'
//@ts-ignore
import changelog from '../../changelog.md'

const STORAGE_KEY = 'changelog-last-seen'

// Parcel transforms changelog.md into an HTML string at build time.
// The first <h2> is the most recent changelog entry (e.g. "14 Avril 2026").
// We use its text content as a token to detect new changelog entries —
// it doesn't need to be a valid date, just a string that changes when new entries are added.
const getLatestChangelogToken = (): string => {
  const match = (changelog as string).match(/<h2[^>]*>(.+?)<\/h2>/)
  return match?.[1] ?? ''
}

// Zustand store so that dismiss() in the WhatsNew page
// immediately hides the dot in the header (both use this hook).
const useChangelogStore = create(() => ({
  lastSeen: localStorage.getItem(STORAGE_KEY),
}))

export const useHasNewChangelog = () => {
  const token = getLatestChangelogToken()
  const lastSeen = useChangelogStore(s => s.lastSeen)

  const hasNew = token !== '' && lastSeen !== token

  const dismiss = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, token)
    useChangelogStore.setState({ lastSeen: token })
  }, [token])

  return { hasNew, dismiss }
}
